var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyNetworks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1652",
    "data-name": "Groupe 1652",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.047,
    height: 33.048,
    viewBox: "0 0 33.047 33.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1727",
    "data-name": "Trac\\xE9 1727",
    d: "M-153.066,261.329a4.52,4.52,0,0,0-4.52,4.52,4.52,4.52,0,0,0,4.52,4.52,4.527,4.527,0,0,0,4.52-4.52A4.52,4.52,0,0,0-153.066,261.329Z",
    transform: "translate(169.593 -249.325)",
    fill: "#3e3e3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1728",
    "data-name": "Trac\\xE9 1728",
    d: "M-210.84,270.888a3.258,3.258,0,0,0-3.262-3.255,3.258,3.258,0,0,0-3.255,3.262,3.258,3.258,0,0,0,3.262,3.255h0A3.269,3.269,0,0,0-210.84,270.888Z",
    transform: "translate(217.357 -254.363)",
    fill: "#3e3e3e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1729",
    "data-name": "Trac\\xE9 1729",
    d: "M-82.057,267.6a3.262,3.262,0,0,0-3.263,3.261,3.262,3.262,0,0,0,3.261,3.264,3.262,3.262,0,0,0,3.263-3.261h0A3.269,3.269,0,0,0-82.057,267.6Z",
    transform: "translate(111.843 -254.336)",
    fill: "#3e3e3e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1730",
    "data-name": "Trac\\xE9 1730",
    d: "M-148.036,333.649a3.259,3.259,0,0,0-3.255,3.262,3.259,3.259,0,0,0,3.262,3.255,3.258,3.258,0,0,0,3.255-3.262h0A3.268,3.268,0,0,0-148.036,333.649Z",
    transform: "translate(164.562 -307.118)",
    fill: "#3e3e3e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1731",
    "data-name": "Trac\\xE9 1731",
    d: "M-148.067,208.089a3.258,3.258,0,0,0,3.253-3.262,3.258,3.258,0,0,0-3.262-3.253,3.258,3.258,0,0,0-3.253,3.261A3.269,3.269,0,0,0-148.067,208.089Z",
    transform: "translate(164.592 -201.573)",
    fill: "#3e3e3e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1732",
    "data-name": "Trac\\xE9 1732",
    d: "M-190.329,313.146a3.269,3.269,0,0,0-4.609,0,3.257,3.257,0,0,0,0,4.606l0,0a3.258,3.258,0,0,0,4.606,0l0,0a3.257,3.257,0,0,0,0-4.606Z",
    transform: "translate(200.205 -289.974)",
    fill: "#3e3e3e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1733",
    "data-name": "Trac\\xE9 1733",
    d: "M-105.791,228.594a3.269,3.269,0,0,0,4.609,0,3.257,3.257,0,0,0,0-4.606l0,0a3.257,3.257,0,0,0-4.606,0l0,0a3.257,3.257,0,0,0,0,4.606Z",
    transform: "translate(128.965 -218.72)",
    fill: "#3e3e3e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1734",
    "data-name": "Trac\\xE9 1734",
    d: "M-101.188,313.146a3.269,3.269,0,0,0-4.609,0,3.257,3.257,0,0,0,0,4.606l0,0a3.258,3.258,0,0,0,4.606,0l0,0a3.257,3.257,0,0,0,0-4.606Z",
    transform: "translate(128.97 -289.974)",
    fill: "#3e3e3e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1735",
    "data-name": "Trac\\xE9 1735",
    d: "M-190.329,223.985a3.257,3.257,0,0,0-4.606,0l0,0a3.257,3.257,0,0,0,0,4.606l0,0a3.269,3.269,0,0,0,4.609,0,3.257,3.257,0,0,0,0-4.606Z",
    transform: "translate(200.205 -218.72)",
    fill: "#3e3e3e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNetworks);
export default __webpack_public_path__ + "static/media/MyNetworks.b4770aa25de5d18a3b1ac2cfc8d9bf84.svg";
export { ForwardRef as ReactComponent };